export const isResourceDeleting = (resource) => resource?.status === 'Deleting';

export function assertResourceAvailable(snapshot, name) {
  if (!snapshot.exists()) throw new Error(`${name} no longer exists.`);
  if (isResourceDeleting(snapshot.data())) {
    throw new Error(`${name} is being deleted. Retry deletion to finish cleanup.`);
  }
}
